import React from 'react';
import { Link } from 'react-router';
import MainNav from './MainNav';
import logo from 'assets/logo.svg';


const Header = (props) => (
    <header className="header">
      <link href="//diegoddox.github.io/react-redux-toastr/4.4/react-redux-toastr.min.css" rel="stylesheet" type="text/css" />
      <link rel="stylesheet" href="//maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css"/>
      <div className="layout__wrapper--fluid  v-center">
        <div className="logo">
          <a href="https://www.livechatinc.com/">
            <img data-no-retina className="no-retina" src={logo} height="32"/>
          </a>
          <Link to="/" className="breadcrumb">
            <span><i className="caret"/> LiveChat tools</span>
            <span><i className="caret"/> Link shortener</span>
          </Link>
        </div>
        <MainNav/>
      </div>
    </header>
);
export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.jsx